import { FabricAccessLevel } from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { ZenityEntityActionInputs, ZenityEntityActionOutputs } from './zenityEntityActions';

export enum UserPermissionsUserType {
  user = 'user',
  azureActiveDirectoryGroup = 'azureActiveDirectoryGroup',
  tenant = 'tenant',
}

export enum UserPermissionsPermissionType {
  ownerOf = 'ownerOf',
  canEdit = 'canEdit',
  canView = 'canView',
}

export interface SingleUserPermissionsActionData {
  identityPlatformResourceId: string;
  displayName: string;
  email: string | null;
  permissionType: UserPermissionsPermissionType;
  identityResourceType: UserPermissionsUserType;
  role: FabricAccessLevel;
}

export interface ListUserPermissionsActionOutputs extends ZenityEntityActionOutputs {
  permissions: SingleUserPermissionsActionData[];
}

export interface RemoveUserPermissionsActionInputs extends ZenityEntityActionInputs {
  identity_platform_resource_id: string;
}

export type RemoveUserPermissionsActionOutputs = ZenityEntityActionOutputs;
